/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListAuditEventsParams = {
action?: string[];
severity?: string[];
actor_query?: string | null;
search?: string | null;
occurred_from?: string | null;
occurred_to?: string | null;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
};
